import { render, staticRenderFns } from "./settings-organization-banner-branding.vue?vue&type=template&id=4f1dcc5a&scoped=true&"
import script from "./settings-organization-banner-branding.vue?vue&type=script&lang=js&"
export * from "./settings-organization-banner-branding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1dcc5a",
  null
  
)

export default component.exports